import { Button } from '../../../components/ui/button';
import { AlertTriangle } from 'lucide-react';

const RetryPanel = ({ title, message, score, threshold, actions = [], testId }) => (
    <div
        className="mt-6 p-8 rounded-2xl bg-amber-500/5 border border-amber-500/20 text-center"
        data-testid={testId}
    >
        <div className="w-16 h-16 mx-auto bg-amber-500/15 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-8 h-8 text-amber-400" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">{title}</h2>
        <p className="text-white/60 max-w-md mx-auto mb-6">{message}</p>
        {score !== undefined && score !== null && (
            <div className="inline-flex items-center gap-6 px-6 py-3 rounded-xl bg-white/5 border border-white/10 mb-6">
                <div>
                    <p className="text-2xl font-bold text-amber-400" data-testid={`${testId}-score`}>
                        {Math.round(score * 100)}%
                    </p>
                    <p className="text-xs text-white/50">Your score</p>
                </div>
                {threshold !== undefined && (
                    <div>
                        <p className="text-2xl font-bold text-white/80">{Math.round(threshold * 100)}%</p>
                        <p className="text-xs text-white/50">Needed to pass</p>
                    </div>
                )}
            </div>
        )}
        <div className="flex flex-wrap justify-center gap-3">
            {actions.map(action => (
                <Button
                    key={action.testId}
                    onClick={action.onClick}
                    variant={action.variant || 'default'}
                    className={action.variant === 'outline'
                        ? 'border-white/20 text-white hover:bg-white/10'
                        : 'bg-indigo-600 hover:bg-indigo-700'}
                    data-testid={action.testId}
                >
                    {action.label}
                </Button>
            ))}
        </div>
    </div>
);

export default RetryPanel;
